/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {ParentBox, relayWrap} from '../../box-utils/ParentBox.react.js';

import {FormattedMessage} from 'react-intl';
import Error from '../system/Error.react.js';
import EmptyContent from '../system/EmptyContent.react';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import MoreLink from '../../box-utils/MoreLink.react';
import './Merk.scss';
import {AsYouType} from 'libphonenumber-js';
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

function phoneFormatter(phone) {
	let asYouType = new AsYouType();
	return asYouType.input(String(phone || ''));
}

class Merk extends ParentBox {

    static handlerName = "merk-contact";

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "merk";
    }

	getServiceName() {
		return "Merk";
	}

    computeRow(merk, idx) {
        let basic = {
            status: {}
        };

        if (merk.basic) {
            basic = merk.basic;
        }

        return (
            <div className="merk-contact-column table-spaced-columns" key={idx + "" + basic.regno}>
				<div key="1"><strong className="dativeryValue">{basic.name}</strong> (<MoreLink link={basic.link || ""} service="Merk" />)</div>
				<div className="panel-columns" key="2">
					{basic.phones && basic.phones.length > 0 ?
						<div key="1">
							<i className="merk-icon fa fa-fw fa-lg fa-phone"></i><span className="merk-contact-title"><FormattedMessage defaultMessage="{count, plural, one {Phone} other {Phones}}" id="merk.phones" values={{count: basic.phones.length}}/></span>
							&nbsp;
							<ul className="merk-li-2">
								{basic.phones.map((phone) => {
									return <li key={phone}><a className="dativeryValue" href={"tel:" + phone}>{phoneFormatter(phone)}</a></li>;
								})}
							</ul>
						</div>
					: null}

					{basic.mobiles && basic.mobiles.length > 0 ?
						<div key="2">
							<i className="merk-icon fa fa-fw fa-lg fa-mobile"></i>  <span className="merk-contact-title"><FormattedMessage defaultMessage="{count, plural, one {Mobile} other {Mobiles}}" id="merk.mobiles"  values={{count: basic.mobiles.length}}/></span>
							&nbsp;
							<ul className="merk-li-2">
								{basic.mobiles.map((mobile) => {
									return <li key={mobile}><a className="dativeryValue" href={"tel:" + mobile}>{phoneFormatter(mobile)}</a></li>;
								})}
							</ul>
						</div>
					: null}

					{basic.emails && basic.emails.length > 0 ?
						<div key="3">
							<i className="merk-icon fa fa-fw fa-lg fa-envelope"></i>  <span className="merk-contact-title"><FormattedMessage defaultMessage="{count, plural, one {Email} other {Emails}}" id="merk.emails" values={{count: basic.emails.length}}/></span>
							&nbsp;
							<ul className="merk-li-2 long">
								{basic.emails.map((email) => {
									return <li key={email}><a className="dativeryValue" href={"mailto:" + email}>{email}</a></li>;
								})}
							</ul>
						</div>
					: null}

					{basic.webs && basic.webs.length > 0 ?
						<div key="4">
							<i className="merk-icon fa fa-fw fa-lg fa-globe"></i>  <span className="merk-contact-title"><FormattedMessage defaultMessage="{count, plural, one {Web} other {Webs}}" id="merk.webs" values={{count: basic.webs.length}} /></span>
							&nbsp;
							<ul className="merk-li-2 long">
								{basic.webs.map((web) => {
									return <li key={web}><a className="dativeryValue" href={web} target="_blank">{web}</a></li>;
								})}
							</ul>
						</div>
					: null}
				</div>
			</div>
		);
	}

	static isEmpty(viewWithData) {
		let {addon} = viewWithData;

		if (addon) {
			addon = safeJSONparse(addon);

			if (addon.merk && Array.isArray(addon.merk) && addon.merk.length > 0 && addon.merk.filter((merk) => Merk.isWithoutContacts(merk)).length > 0) {
				return false;
			}
		}

		return true;
	}

	static isWithoutContacts(merkData) {
		let basic = merkData.basic;

		if ((basic.phones && basic.phones.length > 0) || (basic.mobiles && basic.mobiles.length > 0) || (basic.emails && basic.emails.length > 0) || (basic.webs && basic.webs.length > 0)) {
			return true;
		}

		return false;
	}

    render() {
        try {
            let {addon} = this.props.viewWithData;

            if (addon) {
                addon = safeJSONparse(addon);
                let list;


                if (!Merk.isEmpty(this.props.viewWithData)) {
                    list = addon.merk;
                } else if (this.props.isPreview) {
                    list = [{
                        basic: {
							name: 'Firma s.r.o.',
                            regno: 'CZ5574617',
                            link: 'https://www.merk.cz/search/detail/cz-5574617/',
                            phones: [
                                '+420 789 456 123'
                            ],
                            mobiles: [
                                '+420 789 123 456'
                            ],
                            emails: [
                                'contact@example.com'
                            ],
                            webs: [
                                'https://www.example.com'
                            ]
                        },
                    }];
                } else {
                    return (
                        <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                            <EmptyContent />
                        </BoxDecorator>
                    );
                }

                return (
                    <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                        <div className="merk-contact-columns">
                            <small>
                                    {list.filter((merk) => Merk.isWithoutContacts(merk)).map((merk, idx) => this.computeRow(merk, idx))}
									<div className="clear" key="last"></div>
                            </small>
                        </div>
                    </BoxDecorator>
                );
            }

            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <span>?</span>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(Merk);
